module.exports = __webpack_public_path__ + "static/media/photo_environment.a6ee2ed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideImage/photo_environment.jpg
// module id = 394
// module chunks = 0